import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'
import SignIn from 'src/pages/SignIn.vue'

const routes = [
  {
    path: '/',
    component: DashboardLayout,
    redirect: '/admin/websites'
  },
  {
    path: "/sign-in",
    component: SignIn,
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/websites',
    children: [
      {
        path: 'websites',
        name: 'Websites',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Websites.vue'
        ),
      },
      {
        path: 'discounts',
        name: 'Discounts',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Discounts.vue'
        ),
      },
      {
        path: "customer-overview",
        name: "Customer overview",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/CustomerOverview.vue'
        )
      },
      {
        path: "categories",
        name: "Categories",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Categories.vue'
        ),
      },
      {
        path: 'websites/new',
        name: 'New website',
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/websites/ManageWebsite.vue'
        )
      },
      {
        path: 'websites/edit/:id',
        name: "Edit website",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/websites/ManageWebsite.vue'
        )
      },
      {
        path: 'websites/cms/:id/:cmstype/:section',
        name: "CMS website",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/websites/CmsWebsite.vue'
        )
      },
      {
        path: "accounts",
        name: "Accounts",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Accounts.vue'
        ),
      },
      /* {
        path: "categories",
        name: "Categories",
        component: () => import(
          '../pages/Categories.vue'
        ),
      }, */
      {
        path: "brands",
        name: "",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Brands.vue'
        ),
      },
      {
        path: "suppliers",
        name: "",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Suppliers.vue'
        ),
      },
      {
        path: "all-products",
        name: "alle producten",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/products/AllProducts.vue'
        ),
      },
      {
        path: "advice-order",
        name: "Advice order",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/AdviceOrder.vue'
        ),
      },
      {
        path: "advice-order-new",
        name: "Advice order new",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/AdviceOrderNew.vue'
        ),
      },
      {
        path: "wholesale-orders",
        name: "Wholesale orders",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/WholesaleOrders.vue'
        ),
      },
      {
        path: "wholesale-orders/:id",
        name: "view overview order",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/overview-order-view/EditWholesaleOrder.vue'
        )
      },
      {
        path: "overview-order",
        name: "overview order",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/OverviewOrder.vue'
        ),
      },
      {
        path: "marketing",
        name: "Marketing",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Marketing.vue'
        ),
      },
      {
        path: "replenishment",
        name: "replenishment",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/Replenishment.vue'
        ),
      },
      {
        path: "order/:id",
        name: "view overview order",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/overview-order-view/OverviewOrderView.vue'
        )
      },
      {
        path: "product/new",
        name: "New product",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/products/ManageProduct.vue'
        )
      },
      {
        path: "product/edit/:id",
        name: "Edit product",
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/products/ManageProduct.vue'
        )
      },
      {
        path: "overwrite-product/:id",
        name: "Overwrite product",
        routerEnter: (to, from, next) => to.query.website ? next() : next(`/admin/website-products`),
        component: () => import(
          /* webpackPrefetch: true */
          '../pages/products/ManageProduct.vue'
        )
      },
    ]
  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
